<script setup>
/**
 * "Write it for me" (spec P-8.1), where the owner meets Waslo's default words: Personality, Test it
 * and the Overview's readiness step. It only opens the first-draft screen; nothing is priced here,
 * because nothing runs until she presses Draft there, with the price on it.
 */
import { computed } from 'vue';
import { useRouter } from 'vue-router';

import Banner from 'dashboard/components-next/banner/Banner.vue';
import { frontendURL } from 'dashboard/helper/URLHelper';

import { useWasloAccountId } from '../composables/useWasloAccountId.js';
import { useWasloI18n } from '../i18n.js';

const { t } = useWasloI18n();
const router = useRouter();
const accountId = useWasloAccountId();

const to = computed(() =>
  accountId.value === null
    ? null
    : frontendURL(`accounts/${accountId.value}/waslo/personality/first-draft`)
);

const open = () => {
  if (to.value !== null) router.push(to.value);
};
</script>

<template>
  <Banner
    v-if="to"
    color="blue"
    :action-label="t('WASLO.SETUP_AI.FIRST_DRAFT.OPEN')"
    data-waslo-first-draft-link
    @action="open"
  >
    {{ t('WASLO.SETUP_AI.FIRST_DRAFT.OFFER') }}
  </Banner>
</template>
